import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=0e5a63e4&scoped=true"
import script from "./exchange.vue?vue&type=script&lang=js"
export * from "./exchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5a63e4",
  null
  
)

export default component.exports